module.exports = __webpack_public_path__ + "img/stripe-logo.d74c1a98.svg";